import { DateTime } from 'luxon';

export const DATES = {
	TODAY: 'Today',
	YESTERDAY: 'Yesterday',
	TOMORROW: 'Tomorrow',
	NEXT_7_DAYS: 'Today and Next 7 days',
	NEXT_30_DAYS: 'Today and Next 30 days',
	NEXT_MONTH: 'Next month',
	NEXT_QUARTER: 'Next quarter',
	NEXT_YEAR: 'Next Year',
	LAST_7_DAYS: 'Last 7 days',
	LAST_30_DAYS: 'Last 30 days',
	THIS_MONTH: 'This month',
	LAST_MONTH: 'Last month',
	THIS_QUARTER: 'This quarter',
	LAST_QUARTER: 'Last quarter',
	THIS_YEAR: 'This Year',
	LAST_YEAR: 'Last Year',
	FISCAL_REPORT_RANGE: 'Fiscal report range',
	CUSTOM_RANGE: 'Custom range',
};

export const DATES_ID = {
	TODAY: 'today',
	YESTERDAY: 'yesterday',
	TOMORROW: 'tomorrow',
	NEXT_7_DAYS: 'next_7_days',
	NEXT_30_DAYS: 'next_30_days',
	NEXT_MONTH: 'next_month',
	NEXT_QUARTER: 'next_quarter',
	NEXT_YEAR: 'next_year',
	LAST_7_DAYS: 'last_7_days',
	LAST_30_DAYS: 'last_30_days',
	THIS_MONTH: 'this_month',
	LAST_MONTH: 'last_month',
	THIS_QUARTER: 'this_quarter',
	LAST_QUARTER: 'last_quarter',
	THIS_YEAR: 'this_year',
	LAST_YEAR: 'last_year',
	FISCAL_REPORT_RANGE: 'fiscal_report_range',
	CUSTOM_RANGE: 'custom_range',
};

export const DATES_ARRAY = [
	{
		label: DATES.TODAY,
		id: DATES_ID.TODAY,
		from: DateTime.now().toISODate(),
		to: DateTime.now().plus({ days: 1 }).toISODate(),
		periodOfTime: 'day',
		comparatorFrom: '>=',
		comparatorTo: '<',
	},
	{
		label: DATES.YESTERDAY,
		id: DATES_ID.YESTERDAY,
		from: DateTime.now().minus({ days: 1 }).toISODate(),
		to: DateTime.now().toISODate(),
		periodOfTime: 'day',
		comparatorFrom: '>=',
		comparatorTo: '<',
	},
	{
		label: DATES.TOMORROW,
		id: DATES_ID.TOMORROW,
		from: DateTime.now().plus({ days: 1 }).toISODate(),
		to: DateTime.now().plus({ days: 2 }).toISODate(),
		periodOfTime: 'day',
		comparatorFrom: '>=',
		comparatorTo: '<',
	},
	{
		label: DATES.NEXT_7_DAYS,
		id: DATES_ID.NEXT_7_DAYS,
		from: DateTime.now().toISODate(),
		to: DateTime.now().plus({ days: 8 }).toISODate(),
		periodOfTime: 'day',
		comparatorFrom: '>=',
		comparatorTo: '<',
	},
	{
		label: DATES.NEXT_30_DAYS,
		id: DATES_ID.NEXT_30_DAYS,
		from: DateTime.now().toISODate(),
		to: DateTime.now().plus({ days: 31 }).toISODate(),
		periodOfTime: 'day',
		comparatorFrom: '>=',
		comparatorTo: '<',
	},
	{
		label: DATES.NEXT_MONTH,
		id: DATES_ID.NEXT_MONTH,
		from: DateTime.now().plus({ months: 1 }).startOf('month').toISODate(),
		to: DateTime.now().plus({ months: 1 }).endOf('month').plus({ days: 1 }).toISODate(),
		periodOfTime: 'period',
		comparatorFrom: '>=',
		comparatorTo: '<',
	},
	{
		label: DATES.NEXT_QUARTER,
		id: DATES_ID.NEXT_QUARTER,
		from: DateTime.now().plus({ quarters: 1 }).startOf('quarter').toISODate(),
		to: DateTime.now().plus({ quarters: 1 }).endOf('quarter').plus({ days: 1 }).toISODate(),
		periodOfTime: 'period',
		comparatorFrom: '>=',
		comparatorTo: '<',
	},
	{
		label: DATES.NEXT_YEAR,
		id: DATES_ID.NEXT_YEAR,
		from: DateTime.now().plus({ years: 1 }).startOf('year').toISODate(),
		to: DateTime.now().plus({ years: 1 }).endOf('year').plus({ days: 1 }).toISODate(),
		periodOfTime: 'period',
		comparatorFrom: '>=',
		comparatorTo: '<',
	},
	{
		label: DATES.LAST_7_DAYS,
		id: DATES_ID.LAST_7_DAYS,
		from: DateTime.now().minus({ days: 7 }).toISODate(),
		to: DateTime.now().toISODate(),
		periodOfTime: 'last',
		comparatorFrom: '>=',
		comparatorTo: '<',
	},
	{
		label: DATES.LAST_30_DAYS,
		id: DATES_ID.LAST_30_DAYS,
		from: DateTime.now().minus({ days: 30 }).toISODate(),
		to: DateTime.now().toISODate(),
		periodOfTime: 'last',
		comparatorFrom: '>=',
		comparatorTo: '<',
	},
	{
		label: DATES.THIS_MONTH,
		id: DATES_ID.THIS_MONTH,
		from: DateTime.now().startOf('month').toISODate(),
		to: DateTime.now().endOf('month').plus({ days: 1 }).toISODate(),
		periodOfTime: 'last',
		comparatorFrom: '>=',
		comparatorTo: '<',
	},
	{
		label: DATES.LAST_MONTH,
		id: DATES_ID.LAST_MONTH,
		from: DateTime.now().minus({ months: 1 }).startOf('month').toISODate(),
		to: DateTime.now().startOf('month').toISODate(),
		periodOfTime: 'period',
		comparatorFrom: '>=',
		comparatorTo: '<',
	},
	{
		label: DATES.THIS_QUARTER,
		id: DATES_ID.THIS_QUARTER,
		from: DateTime.now().startOf('quarter').toISODate(),
		to: DateTime.now().endOf('quarter').plus({ days: 1 }).toISODate(),
		periodOfTime: 'last',
		comparatorFrom: '>=',
		comparatorTo: '<',
	},
	{
		label: DATES.LAST_QUARTER,
		id: DATES_ID.LAST_QUARTER,
		from: DateTime.now().minus({ quarters: 1 }).startOf('quarter').toISODate(),
		to: DateTime.now().startOf('quarter').toISODate(),
		periodOfTime: 'period',
		comparatorFrom: '>=',
		comparatorTo: '<',
	},
	{
		label: DATES.THIS_YEAR,
		id: DATES_ID.THIS_YEAR,
		from: DateTime.now().startOf('year').toISODate(),
		to: DateTime.now().endOf('year').plus({ days: 1 }).toISODate(),
		periodOfTime: 'last',
		comparatorFrom: '>=',
		comparatorTo: '<',
	},
	{
		label: DATES.LAST_YEAR,
		id: DATES_ID.LAST_YEAR,
		from: DateTime.now().minus({ years: 1 }).startOf('year').toISODate(),
		to: DateTime.now().startOf('year').toISODate(),
		periodOfTime: 'period',
		comparatorFrom: '>=',
		comparatorTo: '<',
	},
	{
		label: DATES.FISCAL_REPORT_RANGE,
		id: DATES_ID.FISCAL_REPORT_RANGE,
		from: (() => {
			const now = DateTime.now();
			const currentYearFeb1 = now.set({ month: 2, day: 1 });
			return now >= currentYearFeb1
				? currentYearFeb1.toISODate()
				: now.minus({ years: 1 }).set({ month: 2, day: 1 }).toISODate();
		})(),
		to: DateTime.now().endOf('month').plus({ days: 1 }).toISODate(),
		periodOfTime: 'period',
		comparatorFrom: '>=',
		comparatorTo: '<',
	},
	// {
	// 	label: DATES.CUSTOM_RANGE,
	// 	id: DATES_ID.CUSTOM_RANGE,
	// },
];
